import React from 'react';
import Layout from '@components/layout/Layout';
import OrderSubmittedTemplate from '@templates/order/OrderSubmittedTemplate';
import { useLocation, useNavigate } from 'react-router-dom';

const OrderSubmitted = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { newOrderData, userDetails, roFlow, pricing, orderID, contractId } = location.state || {};

  return (
    <Layout isLoggedIn={true}>
      <div className="container xs-max:p-0 pb-8">
        <OrderSubmittedTemplate
          newOrderData={newOrderData}
          userDetails={userDetails}
          contractId={contractId}
          roFlow={roFlow}
          pricing={pricing}
          orderID={orderID}
          navigate={navigate}
        />
      </div>
    </Layout>
  );
};
export default OrderSubmitted;
